import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { showNotification } from '@/services/calculate'
import { formatCurrency } from '@/services/convert'
import { highlightLinkRows } from '@/services/grid'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import _ from 'lodash'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: [
    'takeoffs',
    'columns',
    'costDetails',
    'singleClickEdit',
    'screenIndentifier',
    'sequence',
    'linkTileId',
    'tiles',
    'childTiles',
    'tableId',
    'dropdownData',
    'selectedTiles',
    'isArchive',
  ],
  data() {
    return {
      data: [],
      redrawTable: false,
      loading: false,
      gridOptions: {
        suppressCellSelection: true,
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        suppressContextMenu:
          this.costDetails.isAdjustmentTile || this.isArchive,
        defaultColDef: {
          suppressMovable: true,
          singleClickEdit: false,
          menuTabs: ['filterMenuTab'],
        },
        rowClassRules: {
          // row style function
          lockedRow: function(params) {
            params.editable = false
            return params.data.isLocked
          },
        },
      },
      columnDefs: null,
      frameworkComponents: null,
      width: '100%',
      height: '21rem',
      selectedRowKeys: [],
      selectedRows: [],
      formatCurrency: formatCurrency,
      popupParent: null,
      pinnedTopRowData: [],
      tileList: [],
    }
  },
  beforeMount() {
    this.loadingConfig()
    this.postSort = rowNodes => {
      const takeoffs = []
      for (let i = 0; i < rowNodes.length; i++) {
        takeoffs.push(rowNodes[i].data)
      }
      this.data = [...takeoffs]
    }
  },
  created() {
    this.popupParent = document.querySelector('body')
  },
  mounted() {
    this.loadingConfig()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    takeoffs() {
      this.getData(this.gridOptions)
    },
    linkTileId() {
      this.getData(this.gridOptions)
    },
  },
  methods: {
    loadingConfig() {
      this.frameworkComponents = {
        customFilter: CustomFilter,
        costPriceCellRenderer: CurrencyRenderer,
        toolTipRenderer: ToolTipRenderer,
        actionCellRenderer: ActionRenderer,
      }
    },

    getContextMenuItems(params) {
      const isLinked = params.node && params.node.data.childTileId
      const childTileCount =
        !this.childTiles ||
        (this.childTiles && this.childTiles.tiles.length === 0)
      const isAdjustmentTakeoff =
        params.node && params.node.data.isAdjustmentTakeoff
      const record = params.node && params.node.data
      const selectedTiles =
        this.selectedTiles.length > 0 ? this.selectedTiles : []
      this.tileList = this.tiles.filter(i => !selectedTiles.includes(i.id))
      const tileCount = this.tileList.length === 0

      var result = [
        {
          name: 'Move to new tile',
          disabled: isAdjustmentTakeoff,
          action: () => {
            this.linkTakeoffs(record, undefined, 'new')
          },
          icon: '<i class="fa fa-plus-square-o" />',
        },
        {
          name: 'Move to existing tile',
          disabled: tileCount || isAdjustmentTakeoff,
          icon: '<i class="fa fa-exchange" />',
          subMenu: this.showExistingTiles(record, this.tileList, 'existing'),
        },
        {
          name: 'Link to child',
          disabled: !!isLinked || childTileCount || isAdjustmentTakeoff,
          icon: '<i class="fa fa-link" />',
          subMenu: this.showExistingTiles(
            record,
            _.get(this.childTiles, 'tiles', []),
            'link',
          ),
        },
      ]
      return result
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
      if (!this.costDetails.isAdjustmentTile) {
        this.$emit('onSelectedKeys', this.selectedRows, this.costDetails)
      }
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.selectedRows = selectedNodes.map(node => node.data)
      if (!this.costDetails.isAdjustmentTile) {
        this.$emit('onSelectedKeys', this.selectedRows, this.costDetails)
      }
    },

    getData(params) {
      const displayColumns = this.columns
      displayColumns.map(col => {
        const align = col.field === 'unitCost' ? 'right' : 'left'
        if (col.headerName) {
          col.cellStyle = param =>
            highlightLinkRows(param, align, this.linkTileId)
          col.filter = 'customFilter'
        }
        return col
      })
      params.api.setColumnDefs(displayColumns)
      params.api.sizeColumnsToFit()
      if (this.sequence > 1) {
        this.pinnedTopRowData = this.takeoffs.filter(
          i => i.isAdjustmentTakeoff,
        )
      }
      params.api.setRowData(this.takeoffs.filter(i => !i.isAdjustmentTakeoff))
      const element = document.querySelector('#' + 'projectdetails')
      if (element) {
        this.height =
          Math.round(element.getBoundingClientRect().height) - 160 + 'px'
      }
      if (this.isArchive) {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'checkbox',
              hide: this.isArchive,
            },
          ],
        })
        this.gridOptions.api.sizeColumnsToFit()
      }
    },

    deleteAllRecord() {
      if (this.selectedRowKeys.length > 0) {
        const isLinked = this.selectedRows.some(i => i.childTileId)
        var that = this
        if (isLinked) {
          const h = this.$createElement
          this.$info({
            title: `You can't delete line item which is linked to the tile on child level`,
            content: h('div', {}, [
              h(
                'div',
                { attrs: { class: 'linked-takeoff-div' } },
                that.showLinkedTakeoffs(h),
              ),
              h(
                'p',
                {},
                'Please unselect or unlink the above line items before deleting.',
              ),
            ]),
            onOk() {},
          })
        } else {
          this.$confirm({
            title: `Are you sure want to delete ${this.selectedRowKeys.length} records?`,
            content: h => (
              <div style="color:red">
                <p>
                  This action will delete all information related these rows.
                </p>
                <p>Please confirm.</p>
              </div>
            ),
            onOk() {
              that.confirmDelete(null)
            },
          })
        }
      } else {
        showNotification(
          'warning',
          'Cost Details',
          'Please select at least one line item!',
        )
      }
    },

    confirmDelete() {
      this.loading = true
      const url = projectAPIs.project.asset.actualCost.level.takeoff.add(
        this.$route.params.id,
        this.costDetails.assetId,
        this.costDetails.levelId,
        this.costDetails.id,
      )
      instance
        .delete(url, { data: this.selectedRowKeys })
        .then(response => {
          this.selectedRowKeys.map(element => {
            const findIndex = this.data.findIndex(val => val.id === element)
            if (findIndex > -1) {
              this.data.splice(findIndex, 1)
            }
          })
          this.gridOptions.api.applyTransaction({
            remove: this.selectedRows,
          })
          this.resetAdjustmentTakeoff()
          this.$emit('deleteTakeoff', this.selectedRows)
          this.gridOptions.api.forEachNodeAfterFilter(node => {
            node.setSelected(false)
          })
          this.selectedRowKeys = []
          this.selectedRows = []
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    showTakeoff() {
      this.$emit('showTakeoff', this.costDetails, this.sequence, 'Tile')
    },

    showExistingTiles(record, tiles, type) {
      const subMenu = []
      tiles.forEach(element => {
        subMenu.push({
          name: element.tileName,
          action: () => {
            this.linkTakeoffs(record, element.id, type)
          },
          icon: '<i class="fa fa-bars" />',
          tileDetails: element,
        })
      })
      return subMenu
    },

    showLinkedTakeoffs(h) {
      const row = []
      this.selectedRows
        .filter(i => i.childTileId)
        .forEach(element => {
          row.push(
            h('p', { attrs: { class: 'linked-takeoff' } }, element.takeoff),
          )
        })
      return row
    },

    linkTakeoffs(record, tileId, type) {
      let url = null
      switch (type) {
        case 'new':
        case 'existing':
          url = projectAPIs.project.asset.actualCost.level.tile.move(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.levelId,
            tileId || 0,
          )
          break

        default:
          url = projectAPIs.project.asset.actualCost.level.takeoff.update(
            this.$route.params.id,
            this.costDetails.assetId,
            this.costDetails.levelId,
            this.costDetails.id,
          )
      }

      this.$emit('linkTakeoffs', url, type, record, tileId, this.costDetails)
    },

    resetAdjustmentTakeoff() {
      const tileTotal = this.data.reduce((total, takeoff) => {
        return total + (takeoff.unitCost ? takeoff.unitCost : 0)
      }, 0)
      const pinnedRowData = this.pinnedTopRowData
      if (pinnedRowData.length > 0) {
        let cost = _.get(this.costDetails, 'parentTotal', 0) - tileTotal
        if (
          String(cost) === '-0' ||
          String(cost) === '-0.0' ||
          String(cost) === '-0.00'
        ) {
          cost = 0
        }
        pinnedRowData[0].unitCost = cost
        const contract = this.dropdownData.contract.find(
          i =>
            i.value.split(' - ')[0] ===
              (pinnedRowData[0].unitCost < 0 ? '1.00' : '10.00') ||
            i.value.split(' - ')[0] ===
              (pinnedRowData[0].unitCost < 0 ? '1' : '10'),
        )
        const category = this.dropdownData.category.find(
          i => i.value.split(' - ')[0] === '10000',
        )
        const costType = this.dropdownData.costType.find(
          i =>
            i.costType ===
            (pinnedRowData[0].unitCost < 0
              ? 'Building Indirect'
              : 'Hard Cost (No Indirects)'),
        )
        pinnedRowData[0].mContractId = contract ? contract.id : undefined
        pinnedRowData[0].contract = contract
          ? contract.value.split(' - ')[0]
          : undefined
        pinnedRowData[0].mCategoryCodeId = category ? category.id : undefined
        pinnedRowData[0].categoryCode =
          pinnedRowData[0].unitCost < 0
            ? undefined
            : category
              ? category.value.split(' - ')[0]
              : undefined
        pinnedRowData[0].mCostTypeId = costType ? costType.id : undefined
        pinnedRowData[0].costType = costType ? costType.costType : undefined
        this.pinnedTopRowData = pinnedRowData
        this.gridOptions.api.setPinnedTopRowData(pinnedRowData)
      }
    },

    gridSizeChanged(e) {
      const element = document.querySelector('#tileTakeoffTable')
      if (element) {
        this.gridOptions.api.sizeColumnsToFit()
      }
    },
  },
}
